import { render, staticRenderFns } from "./ReservePage.vue?vue&type=template&id=53588d0e&scoped=true"
import script from "./ReservePage.vue?vue&type=script&lang=js"
export * from "./ReservePage.vue?vue&type=script&lang=js"
import style0 from "./ReservePage.vue?vue&type=style&index=0&id=53588d0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53588d0e",
  null
  
)

export default component.exports